import { toast } from 'react-toastify'
import instance from '../../utils/Axios'

import {
  GET_ASSETS,
  GET_ASSETS_LOADING,
  REMOVE_SIGNING_ASSETS,
  SAVE_ASSETS,
  DELETE_ASSET,
  RESET_SIGNING_ASSETS,
} from './Types'
import { AssetProcessTypes } from '../../constants'

export const setSignAsset = (assetData) => (dispatch) => {
  dispatch({
    type: SAVE_ASSETS,
    payload: assetData,
  })
}

export const resetSigningAssets = () => (dispatch) => {
  dispatch({
    type: RESET_SIGNING_ASSETS,
    payload: [],
  })
}

// Save Uploaded Assets
export const saveAssets =
  (
    assetData,
    assetType,
    copyright,
    processType = AssetProcessTypes.Full,
    userId,
    completeAssetsUpload,
    licenseOrProvenance,
  ) =>
  (dispatch) => {
    dispatch({
      type: GET_ASSETS_LOADING,
      payload: true,
    })
    instance
      .post('/assets', {
        assets: assetData,
        assetType,
        copyright,
        processType,
        userId,
        licenseOrProvenance,
      })
      .then((res) => {
        if (res.data.result !== 'error') {
          dispatch({
            type: SAVE_ASSETS,
            payload: res.data.message,
          })
          completeAssetsUpload(false)
          return
        }
        toast.error(res.data.message)
        completeAssetsUpload(true)
      })
      .catch((err) => {
        completeAssetsUpload(true)
        toast.error(err?.response?.data?.message || 'Error saving assets')
      })
      .finally(() => {
        dispatch({
          type: GET_ASSETS_LOADING,
          payload: false,
        })
      })
  }

// Delete Uploaded Assets
export const deleteAsset = (id) => (dispatch) => {
  instance
    .delete(`/assets/${id}/delete`)
    .then(() => {
      toast.success('Asset deleted successfully')
      setTimeout(() => window.location.reload(), 500)
    })
    .catch(() => {
      toast.error('Error deleting asset')
    })
}

// Get Uploaded Assets
export const getAssets = () => (dispatch) => {
  dispatch({
    type: GET_ASSETS_LOADING,
    payload: true,
  })
  instance
    .get('/assets')
    .then((res) => {
      dispatch({
        type: GET_ASSETS,
        payload: res.data.message,
      })
    })
    .catch(() => {
      toast.error('Error fetching assets')
    })
    .finally(() => {
      dispatch({
        type: GET_ASSETS_LOADING,
        payload: false,
      })
    })
}

// Save Uploaded Assets
export const removeSignAsset = (removeAll, name) => (dispatch) => {
  dispatch({
    type: REMOVE_SIGNING_ASSETS,
    payload: { name, removeAll },
  })
}
